import Login from '../firebase/login';
import LogMeout from '../firebase/logout';
import SeatJson from '../firebase/seats';
import Events from '../firebase/events';
import Assets from '../firebase/assets';
import Shows from '../firebase/shows';
import Teams from '../firebase/teams';

export function userLogin(data) {
  // let teamId="ASQKCyZWQgcMAk2arKky";
  // let eventId="Xh4eNu3rnDyCpwA9kTQU";
  // return Events.getSingleEvent(teamId, eventId)
    return Login.userlogin(data);
  }



export function userRegister(data) {
    return  Login.registerUser(data);
}
export function AddAccount(data) {
  return  Login.addAccount(data);
}

export function seatSection(data) {
  return  SeatJson.addSeatJson(data);
}
export function seatSectionKeys(data) {
  return  SeatJson.addSeatSectionKeys(data);
}

export function getSeats() {
  return  SeatJson.getSeats();
}

export function getEventsData() {
    return  Events.getEvents();
}

export function getEventsByTeam(teamId){
 return Events.getEventsByTeam(teamId)
}
export function forgotPassword(data) {
  // return axios.post("/forgotPassword", data);
}


export async function  generateData (data,id){
  let data1 = data;
  console.log("Data 1",data1)
  // let teams = await Teams.addTeams(data);
  // console.log("team_id",teams);

  return Events.addEvents(data1,id);
}

export async function  generateTeamData (data){
  return Teams.addTeams(data);
}

export function getTeamsData() {
  return  Teams.getTeams();
}

export function getTeamById(id) {
  return  Teams.getTeamById(id);
}

export function getMyEventData(team_id,MyId){
  // let MyId="HU5fnFyAC55hp9eUF0Cz";
  let Result =  Events.getSingleEvent(team_id,MyId);
  return Result;
}

export function getMyTeamData(MyId){
  let Result =  Teams.getSingleTeam(MyId);
  return Result;
}

export function UpdateEvents(teamId,MyId, data){
  return Events.UpdateEvents(teamId,MyId, data);
}

export function UpdateTeam(MyId, data){
  return Teams.UpdateTeam(MyId, data);
}



export function deleteEvent(data){
  return Events.DeleteData(data);
}

export function deleteEventInTeams(data,teamId){
  return Events.deleteEventInTeams(data,teamId);
}

export function deleteTeam(data){
  return Teams.DeleteTeam(data);
}

export function generateAssetsData(data){
  return Assets.addAsset(data)
}

export function loggingout(){
  return LogMeout.Logout()
}
  

export function getAssetsInfo(){
  return Assets.getAssets()
}

export function Updateasset(id, Data){
  return Assets.UpdateAssets(id, Data)
}


// export function generateShowsData(data){
//   return data
// }

export function FetchUser(){
  return Login.getUserDetails();
}

export function AddShow(data){
  return Shows.addShow(data);
}

export function GetShows(){
  return Shows.getShows();
}
export function DeleteShows(showId){
  return Shows.DeleteShow(showId);
}

export function getAuthUserLists(){
  return  Events.ListAllUsers();
}
export function deleteAuthUser(uid){
  return  Events.deleteAuthUser(uid);
}